import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
  padding: ${props => props.theme.spacing.sp16} 0 ${props => props.theme.spacing.sp32};
`
